// import React, { Component } from 'react'
// // import '../bratilius-theme-package/assets-minified/all-demo.css'
// import '../CSS/assets-minified/all-demo.css'
// // import '../CSS/css/bootstrap.css'
// import Cookies from 'universal-cookie'
// import { Loader } from 'react-overlay-loader'
// import { url } from '../components/helper'
// import Zoom from 'react-reveal/Zoom'

// class Login extends Component {
//     constructor(props) {
//         super(props)
//         this.validateUsername = this.validateUsername.bind(this)
//         this.attemptLogin = this.attemptLogin.bind(this)
//         this.makeSleep = this.makeSleep.bind()
//         this.enable_btn = this.enable_btn.bind(this)
//         this.togglePasswordView = this.togglePasswordView.bind(this)
//         this.state = {
//             usernameErrorMsgHidden: true,
//             loginErrorMessageHidden: true,
//             showSpinner: true,
//             login_btn_disabled: true,
//             loading: false,
//             loginErrorMessage: '',
//             passwordViewicon: 'fa fa-eye passviewicon',
//         }
//     }

//     componentWillMount() {
//         const cookies = new Cookies()
//         var loginStatus = cookies.get('loggedIn')
//         if (loginStatus === 'true') {
//             window.location = '/dashboard'
//         }
//     }

//     validateUsername() {
//         this.setState({ loginErrorMessageHidden: true })
//         this.enable_btn()
//         // this.setState({loginErrorMessageHidden:false})
//         var usernameField = document.getElementById('inputEmail')
//         var fieldVal = usernameField.value

//         var usernameRegex = /^[a-zA-Z0-9]+$/
//         var isCorrect = usernameRegex.test(fieldVal)
//         if (isCorrect === false) {
//             document.getElementById('inputEmail').style.border =
//                 '1px solid #5887B5'
//             this.setState({
//                 usernameErrorMsgHidden: false,
//             })
//         } else {
//             document.getElementById('inputEmail').style.border = ''
//             this.setState({
//                 usernameErrorMsgHidden: true,
//             })
//         }
//     }

//     makeSleep(event) {
//         alert('test')
//     }

//     enable_btn = () => {
//         var usernameField = document.getElementById('inputEmail').value
//         var passwordField = document.getElementById('inputPassword').value
//         var usernameRegex = /^[a-zA-Z0-9]+$/
//         var isCorrect = usernameRegex.test(usernameField)
//         if ((isCorrect === true) & (passwordField !== '')) {
//             this.setState({ login_btn_disabled: false })
//         } else {
//             this.setState({ login_btn_disabled: true })
//         }
//     }
//     attemptLogin(event) {
//         this.setState({
//             loading: true,
//         })
//         var login_this = this
//         var usernameField = document.getElementById('inputEmail').value
//         var passwordField = document.getElementById('inputPassword').value
//         event.preventDefault()
//         var http = new XMLHttpRequest()
//         http.open('POST', url + '/api/user/login', true)
//         http.setRequestHeader(
//             'Content-type',
//             'application/x-www-form-urlencoded'
//         )
//         http.onreadystatechange = function () {
//             if (http.readyState === 4 && http.status === 200) {
//                 var json = JSON.parse(http.responseText)
//                 if (json.status === 200) {
//                     const cookies = new Cookies()
//                     cookies.set('loggedIn', 'true', { path: '/' })
//                     cookies.set('user_id', json.user_id, { path: '/' })
//                     cookies.set('username', json.username, { path: '/' })
//                     cookies.set('firstname', json.first_name, { path: '/' })
//                     cookies.set('lastname', json.last_name, { path: '/' })
//                     cookies.set('token', json.token, { path: '/' })
//                     cookies.set('superuser', json.is_superuser, { path: '/' })
//                     cookies.set(
//                         'organization-admin',
//                         json.is_organisation_admin,
//                         { path: '/' }
//                     )
//                     cookies.set('branch-admin', json.is_branch_admin, {
//                         path: '/',
//                     })
//                     cookies.set('branch-user', json.is_branch_user, {
//                         path: '/',
//                     })
//                     // debugger;
//                     login_this.setState({
//                         showSpinner: true,
//                     })
//                     window.location = '/dashboard'
//                     // alert("Logged in");
//                 }
//                 if (json.status === 401) {
//                     login_this.setState({
//                         showSpinner: true,
//                         loginErrorMessageHidden: false,
//                         loginErrorMessage:
//                             'Your account has been blocked. Contact your administrator',
//                         loading: false,
//                     })
//                 }
//                 if (json.status === 400) {
//                     login_this.setState({
//                         showSpinner: true,
//                         loginErrorMessageHidden: false,
//                         loginErrorMessage:
//                             'Incorrect Password.Please enter correct password',
//                         loading: false,
//                     })
//                 }
//                 if (json.status === 404) {
//                     login_this.setState({
//                         showSpinner: true,
//                         loginErrorMessageHidden: false,
//                         loginErrorMessage:
//                             'Could not find a user having this username.',
//                         loading: false,
//                     })
//                 }
//             }
//         }
//         http.onerror = function () {
//             login_this.setState({
//                 showSpinner: true,
//                 loginErrorMessageHidden: false,
//                 loginErrorMessage: 'Sorry could not complete login',
//                 loading: false,
//             })
//         }
//         http.ontimeout = function () {
//             login_this.setState({
//                 showSpinner: true,
//                 loginErrorMessageHidden: false,
//                 loginErrorMessage: 'Sorry could not complete login',
//                 loading: false,
//             })
//         }
//         alert(1)
//         console.log("http", http)
//         alert(2)
//         http.send('username=' + usernameField + '&password=' + passwordField)

//     }

//     togglePasswordView = () => {
//         var input = document.getElementById('inputPassword')
//         if (input.type === 'password') {
//             input.type = 'text'
//             this.setState({
//                 passwordViewicon: 'fas fa-eye-slash passviewicon',
//             })
//         } else {
//             input.type = 'password'
//             this.setState({
//                 passwordViewicon: 'fas fa-eye passviewicon',
//             })
//         }
//     }

//     render() {
//         return (
//             <div>
//                 <div className="center-vertical">
//                     <div className="center-content">
//                         <Loader loading={this.state.loading} fullPage={true} />
//                         <Zoom>
//                             <form
//                                 action=""
//                                 id="login-validation"
//                                 className="col-md-4 center-margin"
//                                 method=""
//                             >
//                                 <h3 className="text-center pad25B font-gray text-transform-upr font-size-23">
//                                     Kanji Admin
//                                 </h3>
//                                 <div
//                                     id="login-form"
//                                     className="content-box modal-content"
//                                 >
//                                     <div className="content-box-wrapper pad20A">
//                                         <div className="form-group">
//                                             <label htmlFor="exampleInputEmail1">
//                                                 Username:
//                                             </label>
//                                             <div className="input-group input-group-lg">
//                                                 <i className="fa fa-user inputicon"></i>
//                                                 <input
//                                                     type="text"
//                                                     className="form-control"
//                                                     id="inputEmail"
//                                                     onChange={
//                                                         this.validateUsername
//                                                     }
//                                                     placeholder="Enter Username"
//                                                     maxLength="40"
//                                                 ></input>
//                                             </div>
//                                             <div
//                                                 class="isa_error"
//                                                 hidden={
//                                                     this.state
//                                                         .usernameErrorMsgHidden
//                                                 }
//                                             >
//                                                 <i class="fa fa-times-circle"></i>
//                                                 <b>Username is not valid</b>
//                                             </div>
//                                         </div>
//                                         <div className="form-group">
//                                             <label htmlFor="exampleInputPassword1">
//                                                 Password:
//                                             </label>
//                                             <div className="input-group input-group-lg">
//                                                 <i class="fas fa-key inputicon"></i>
//                                                 <input
//                                                     type="password"
//                                                     className="form-control"
//                                                     id="inputPassword"
//                                                     onChange={this.enable_btn}
//                                                     placeholder="Enter Password"
//                                                 ></input>
//                                                 <i
//                                                     className={
//                                                         this.state
//                                                             .passwordViewicon
//                                                     }
//                                                     title="Show password"
//                                                     onClick={
//                                                         this.togglePasswordView
//                                                     }
//                                                 ></i>
//                                             </div>
//                                             <div
//                                                 class="isa_error"
//                                                 hidden={
//                                                     this.state
//                                                         .loginErrorMessageHidden
//                                                 }
//                                             >
//                                                 <i class="fa fa-times-circle"></i>
//                                                 <b>
//                                                     {
//                                                         this.state
//                                                             .loginErrorMessage
//                                                     }
//                                                 </b>
//                                             </div>
//                                         </div>
//                                         <div className="row">
//                                             <div className="col-md-6"></div>
//                                             <div class="text-right col-md-6">
//                                                 <a
//                                                     href="/forgotpassword"
//                                                     class="switch-button"
//                                                     switch-target="#login-forgot"
//                                                     title="Recover password"
//                                                 >
//                                                     Forgot your password?
//                                                 </a>
//                                             </div>
//                                         </div>
//                                     </div>
//                                     <div className="button-pane">
//                                         <button
//                                             type="submit"
//                                             className="btn btn-block btn-primary"
//                                             onClick={this.attemptLogin}
//                                             disabled={
//                                                 this.state.login_btn_disabled
//                                             }
//                                         >
//                                             Login
//                                         </button>
//                                     </div>
//                                 </div>
//                             </form>
//                         </Zoom>
//                     </div>
//                 </div>
//             </div>
//         )
//     }
// }

// export default Login

import React from 'react'
import { Loader } from 'react-overlay-loader'
import Zoom from 'react-reveal/Zoom'
import Cookies from 'universal-cookie'
import { url } from '../components/helper'
import '../CSS/assets-minified/all-demo.css'

const Login = () => {
    const [usernameErrorMsgHidden, setUsernameErrorMsgHidden] =
        React.useState(true)
    const [loginErrorMessageHidden, setLoginErrorMessageHidden] =
        React.useState(true)
    const [showSpinner, setShowSpinner] = React.useState(true)
    const [loginBtnDisabled, setLoginBtnDisabled] = React.useState(true)
    const [loading, setLoading] = React.useState(false)
    const [loginErrorMessage, setLoginErrorMessage] = React.useState('')
    const [passwordViewicon, setPasswordViewIcon] = React.useState(
        'fa fa-eye passviewicon'
    )

    // Check if user has been logged in
    const navigateDashboard = () => {
        const cookies = new Cookies()
        const token = cookies.get('token')
        if (token) {
            window.location = '/dashboard'
        }
    }

    //Why?
    const enableBtn = () => {
        const usernameField = document.getElementById('inputEmail').value
        const passwordField = document.getElementById('inputPassword').value
        const usernameRegex = /^[a-zA-Z0-9]+$/
        const isCorrect = usernameRegex.test(usernameField)

        console.log('RES', isCorrect && passwordField !== '')
        setLoginBtnDisabled(!(isCorrect && passwordField !== ''))
    }

    const makeSleep = () => {
        alert('Test')
    }

    //Check if username submitted is valid
    const validateUsername = () => {
        //Enable the button
        enableBtn()

        //Grab and validate username
        const username = document.getElementById('inputEmail').value
        const usernameRegex = /^[a-zA-Z0-9]+$/
        const isCorrect = usernameRegex.test(username)

        //Render error message
        if (isCorrect) {
            document.getElementById('inputEmail').style.border = ''
            setUsernameErrorMsgHidden(true)
        } else {
            document.getElementById('inputEmail').style.border =
                '1px solid #5887B5'
            setUsernameErrorMsgHidden(false)
        }
    }

    // Set cookie variable from the beginning
    const setNewCookies = (json) => {
        const cookies = new Cookies()
        cookies.set('loggedIn', 'true', { path: '/' })
        cookies.set('user_id', json.user_id, { path: '/' })
        cookies.set('username', json.username, { path: '/' })
        cookies.set('firstname', json.first_name, { path: '/' })
        cookies.set('lastname', json.last_name, { path: '/' })
        cookies.set('token', json.token, { path: '/' })
        cookies.set('superuser', json.is_superuser, { path: '/' })
        cookies.set('organization-admin', json.is_organisation_admin, {
            path: '/',
        })
        cookies.set('branch-admin', json.is_branch_admin, { path: '/' })
        cookies.set('branch-user', json.is_branch_user, { path: '/' })
    }

    // Set all states appropriately when error occurs
    const setErrorState = (errMsg) => {
        setShowSpinner(true)
        setLoginErrorMessageHidden(false)
        setLoading(false)
        setLoginErrorMessage(errMsg)
    }

    //Execute Login, redirects accordingly
    const handleLogin = async (event) => {
        setLoading(true)
        event.preventDefault() //Fails without this line

        const username = document.getElementById('inputEmail').value
        const password = document.getElementById('inputPassword').value
        const newLogin = {
            username: username,
            password: password,
        }
        const options = {
            method: 'POST',
            headers: {
                'Content-type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams(Object.entries(newLogin)).toString(),
        }

        try {
            console.log('options', options)
            const res = await fetch(`${url}/api/user/login`, options)
            const data = await res.json()

            //If Success
            console.log('res', res)
            console.log('data', data)

            //Status store in data, parse status
            switch (data.status) {
                case 200:
                    setNewCookies(data)
                    setShowSpinner(false)
                    window.location = '/dashboard'
                    break
                case 401:
                    setErrorState(
                        'Your account has been blocked. Contact your administrator'
                    )
                    break
                case 400:
                    setErrorState(
                        'Incorrect Password.Please enter correct password'
                    )
                    break
                case 404:
                    setErrorState('Could not find a user having this username.')
                    break
            }
        } catch (err) {
            console.log('ERR', err)
        }
    }

    const handleOauthLogin = async (event) => {
        event.preventDefault()
        setLoading(true)
        const res = await fetch(`${url}/api/oauth/login`)
        const data = await res.json()

        window.location.href = data.auth_url
    }

    //Toggle password viewer
    const togglePasswordView = () => {
        let password = document.getElementById('inputPassword')
        if (password.type === 'password') {
            password.type = 'text'
            setPasswordViewIcon('fas fa-eye-slash passviewicon')
        } else {
            password.type = 'password'
            setPasswordViewIcon('fas fa-eye passviewicon')
        }
    }

    //Run on render
    React.useEffect(() => {
        navigateDashboard()
    }, [])

    return (
        <div>
            <div className="center-vertical">
                <div className="center-content">
                    <Loader loading={loading} fullPage={true} />
                    {/* <Zoom>
                        <form
                            action=""
                            id="login-validation"
                            className="col-md-4 center-margin"
                            method=""
                        >
                            <h3 className="text-center pad25B font-gray text-transform-upr font-size-23">
                                Kanji Admin
                            </h3>
                            <div
                                id="login-form"
                                className="content-box modal-content"
                            >
                                <div className="content-box-wrapper pad20A">
                                    <div className="form-group">
                                        <label htmlFor="exampleInputEmail1">
                                            Username:
                                        </label>
                                        <div className="input-group input-group-lg">
                                            <i className="fa fa-user inputicon"></i>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="inputEmail"
                                                onChange={validateUsername}
                                                placeholder="Enter Username"
                                                maxLength="40"
                                            ></input>
                                        </div>
                                        <div
                                            class="isa_error"
                                            hidden={usernameErrorMsgHidden}
                                        >
                                            <i class="fa fa-times-circle"></i>
                                            <b>Username is not valid</b>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="exampleInputPassword1">
                                            Password:
                                        </label>
                                        <div className="input-group input-group-lg">
                                            <i class="fas fa-key inputicon"></i>
                                            <input
                                                type="password"
                                                className="form-control"
                                                id="inputPassword"
                                                onChange={enableBtn}
                                                placeholder="Enter Password"
                                            ></input>
                                            <i
                                                className={passwordViewicon}
                                                title="Show password"
                                                onClick={togglePasswordView}
                                            ></i>
                                        </div>
                                        <div
                                            class="isa_error"
                                            hidden={loginErrorMessageHidden}
                                        >
                                            <i class="fa fa-times-circle"></i>
                                            <b>{loginErrorMessage}</b>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6"></div>
                                        <div class="text-right col-md-6">
                                            <a
                                                href="/forgotpassword"
                                                class="switch-button"
                                                switch-target="#login-forgot"
                                                title="Recover password"
                                            >
                                                Forgot your password?
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="button-pane">
                                    <button
                                        className="btn btn-block btn-primary"
                                        onClick={handleLogin}
                                        disabled={loginBtnDisabled}
                                    >
                                        Login
                                    </button>
                                </div>
                            </div>
                        </form>
                    </Zoom> */}
                    <Zoom>
                        <form
                            action=""
                            id="login-validation"
                            className="col-md-4 center-margin"
                            method=""
                        >
                            <h3 className="text-center font-gray font-size-23">
                                Kanji Admin
                            </h3>
                            <div
                                id="login-form"
                                className="content-box modal-content"
                            >
                                <div className="content-box-wrapper h-100">
                                    <div className="form-group">
                                        <button
                                            className="btn btn-block btn-primary font-size-18"
                                            onClick={handleOauthLogin}
                                        >
                                            Login with Microsoft
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </Zoom>
                </div>
            </div>
        </div>
    )
}

export default Login

/**
 * Notes:
 * - EnableBtn redundant, need not do two checks
 * - Better way of password icon than internal change
 * - Page navigation could be better
 *
 */



// WEBPACK FOOTER //
// src/Routes/Login.js